<template>
  <div v-html="html" />
</template>
<script>
export default {
  name: "LandingPage",
  data: () => ({
    html: "",
  }),
  created() {
    this.getHtml();
  },
  methods: {
    async getHtml() {
      const endpoint = `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/landingpage/${
        this.$route.params.lp_id
      }.html`;

      const response = await fetch(endpoint);

      if (response.status === 403) {
        this.$router.push("/page/register");
        return;
      }

      const html = await response.text();
      this.html = html;
    },
  },
};
</script>
